import { deLocalizeUrl } from "$lib/paraglide/runtime";

export const reroute = (request) => {
  // console.log('reroute', request.url);
  // console.log('deLocalizeUrl', deLocalizeUrl(request.url));
  return deLocalizeUrl(request.url).pathname;
};

// import { i18n } from '$lib/i18n';

/** @type {import("@sveltejs/kit").Reroute} */
// export const reroute = i18n.reroute();
